import { useEffect, useRef } from 'react';
import { categories } from '@/mocks/products';

function CategoriesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('.cat-animate').forEach((el) => {
              el.classList.add('animate-in');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
          <div className="cat-animate opacity-100 translate-y-0 transition-all duration-700">
            <span className="inline-block text-xs font-medium text-primary-700 tracking-wider uppercase mb-2">
              Navegue por Categoria
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
              Encontre o que você procura
            </h2>
          </div>
          <p className="cat-animate opacity-100 translate-y-0 transition-all duration-700 delay-100 text-sm md:text-base text-foreground-600 max-w-md">
            Explore nossas categorias e descubra peças encantadoras para cada momento da infância.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((category, index) => (
            <a
              key={category.id}
              href="#catalogo"
              onClick={(e) => {
                e.preventDefault();
                window.dispatchEvent(new CustomEvent('catalog:filter', { detail: { category: category.id } }));
                document.querySelector('#catalogo')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`cat-animate opacity-100 translate-y-0 transition-all duration-700 group`}
              style={{ transitionDelay: `${150 + index * 100}ms` }}
            >
              <div className="relative rounded-xl overflow-hidden bg-background-200 aspect-[4/3] group-hover:shadow-md transition-all duration-300">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-white mb-1">
                    {category.name}
                  </h3>
                  <p className="text-sm text-white/80">{category.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>

      <style>{`
        .cat-animate {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
        .cat-animate.group {
          opacity: 1 !important;
        }
      `}</style>
    </section>
  );
}

export default CategoriesSection;